import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Form, Button, Container, Alert, Row, Col } from "react-bootstrap";
import axios from "axios";
import { useTranslation } from 'react-i18next';


const DriverDebtDetails = () => {
    const { t } = useTranslation();

    const { id } = useParams();
    const navigate = useNavigate();
    const [debt, setDebt] = useState(null);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [validationError, setValidationError] = useState(null);

    useEffect(() => {
        axios.get("https://godrive.com.pl/api/users")
            .then((res) => setUsers(res.data))
            .catch(() => console.warn("Не вдалося отримати список користувачів"));

        axios.get(`https://godrive.com.pl/api/drivers-debts/${id}`)
            .then((res) => {
                setDebt(res.data);
                setLoading(false);
            })
            .catch(() => {
                setError("Не вдалося завантажити дані боргу");
                setLoading(false);
            });
    }, [id]);

    const validateForm = () => {
        if (!debt.debt_total || parseFloat(debt.debt_total) <= 0) {
            setValidationError("Сума боргу повинна бути більше 0");
            return false;
        }
        if (!debt.debt_name.trim()) {
            setValidationError("Назва боргу не може бути порожньою");
            return false;
        }
        if (!debt.debt_create_desc.trim()) {
            setValidationError("Опис боргу не може бути порожнім");
            return false;
        }
        setValidationError(null);
        return true;
    };

    const handleUpdate = () => {
        if (!validateForm()) return;

        axios.put(`https://godrive.com.pl/api/drivers-debts/${id}`, debt)
            .then(() => {
                setUpdateSuccess(true);
                setTimeout(() => {
                    setUpdateSuccess(false);
                    navigate("/admin/driver-debts"); // Перехід на сторінку з боргами
                }, 1000);
            })
            .catch(() => alert("Помилка при оновленні"));
    };

    if (loading) return <p>{t("loading")}...</p>;
    if (error) return <Alert variant="danger">{error}</Alert>;
    if (!debt) return <p>{t("noRecords")}</p>;

    const driver = users.find(user => user.id === debt.driver_id);
    const driverName = driver ? `${driver.firstName} ${driver.lastName}` : "Невідомий водій";

    return (
        <Container className="mt-4">
            <h2>{t("debt")} {t("description").toLocaleLowerCase()}</h2>

            {updateSuccess && <Alert variant="success">{t("success")}..</Alert>}
            {validationError && <Alert variant="danger">{validationError}</Alert>}

            <Row className="mb-3">
                <Col md={6}>
                    <strong>{t("driver")}:</strong> {driverName}
                </Col>
                <Col md={3}>
                    <strong>{t("week")}:</strong> {debt.week_number}
                </Col>
                <Col md={3}>
                    <strong>{t("year")}:</strong> {debt.year}
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={6}>
                    <strong>{t("created")}:</strong> {new Date(debt.created_at).toLocaleDateString()}
                </Col>
                {debt.balance && (
                    <Col md={6}>
                        <strong>{t("debt")} {t("value")}:</strong> {debt.balance}
                    </Col>
                )}
            </Row>

            <Form>
                <Form.Group>
                    <Form.Label>{t("debt")} {t("value").toLocaleLowerCase()}:</Form.Label>
                    <Form.Control
                        type="number"
                        value={debt.debt_total}
                        onChange={(e) => setDebt({ ...debt, debt_total: e.target.value })}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>{t("debt")} {t("name").toLocaleLowerCase()}</Form.Label>
                    <Form.Control
                        type="text"
                        value={debt.debt_name}
                        onChange={(e) => setDebt({ ...debt, debt_name: e.target.value })}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>{t("debt")} {t("description").toLocaleLowerCase()}</Form.Label>
                    <Form.Control
                        as="textarea"
                        value={debt.debt_create_desc}
                        onChange={(e) => setDebt({ ...debt, debt_create_desc: e.target.value })}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>{t("status")}</Form.Label>
                    <Form.Select
                        value={debt.debt_status}
                        onChange={(e) => setDebt({ ...debt, debt_status: e.target.value })}
                    >
                        <option value="open">{t("active")}</option>
                        <option value="closed">{t("inactive")}</option>
                    </Form.Select>
                </Form.Group>

                <Button variant="primary" onClick={handleUpdate} className="mt-3">{t("save")}</Button>
                <Button variant="secondary" className="mt-3 ms-2" onClick={() => navigate(-1)}>{t("back")}</Button>
            </Form>
        </Container>
    );
};

export default DriverDebtDetails;
